<template>
	<v-overlay :dark="false" :absolute="false" :value="visible" :z-index="9999">
		<div class="input-modal confirm-navigation-dialog">
			<div class="input-modal-header confirm-navigation-header">
				<h1 class="input-modal-header-title confirm-navigation-title">WARNING</h1>
				<v-btn icon @click="handleStay" :disabled="loading">
					<v-icon v-text="'mdi-close'"></v-icon>
				</v-btn>
			</div>
			<div class="input-modal-content">
				<div class="confirm-navigation-message">
					Page has not been saved.<br />
					Are you sure you want to leave?
				</div>

				<div class="input-modal-content-actions">
					<v-btn
						color="primary"
						depressed
						:loading="loading"
						:disabled="loading"
						@click="handleSaveAndLeave"
						ref="saveButton"
					>
						Save &amp; Continue
					</v-btn>
					<v-btn
						outlined
						depressed
						:disabled="loading"
						@click="handleStay"
					>
						Stay on Page
					</v-btn>
				</div>

				<div class="confirm-navigation-discard">
					<v-btn
						text
						small
						color="error"
						:disabled="loading"
						@click="handleLeave"
					>
						Discard changes
					</v-btn>
				</div>
			</div>
		</div>
	</v-overlay>
</template>

<script>
export default {
	name: "ConfirmNavigationDialog",

	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},

	watch: {
		visible(newVal) {
			if (newVal) {
				// Focus the "Save & Continue" button when dialog opens
				this.$nextTick(() => {
					if (this.$refs.saveButton && this.$refs.saveButton.$el) {
						this.$refs.saveButton.$el.focus();
					}
				});
			}
		},
	},

	methods: {
		handleStay() {
			this.$emit('stay');
		},

		handleLeave() {
			this.$emit('leave');
		},

		handleSaveAndLeave() {
			this.$emit('save-and-leave');
		},
	},
};
</script>

<style lang="scss" scoped>
.v-overlay {
	::v-deep {
		.v-overlay__content {
			width: 95%;
		}
	}
}

.confirm-navigation-dialog {
	max-width: 50rem;
}

.confirm-navigation-header {
	.confirm-navigation-title {
		font-weight: 700;
		color: #ff5252; // Vuetify error color for warning emphasis
	}
}

.confirm-navigation-message {
	font-size: 1.6rem;
	text-align: center;
	margin-bottom: 1rem;
}

.confirm-navigation-discard {
	text-align: center;
	margin-top: 1.2rem;
}
</style>
